export default "__VITE_ASSET__axMkrrJE__"